/* cria um tipo de interface que obriga o desenvolvedor a inserir a propriedade
data dentro do objeto que será enviado para o modal e seu filho */
export class MdnModalConfig<D = any> {
    data?: D;
}
